/**
 * Dieziqlo Shopify Theme JavaScript
 */

(function() {
  'use strict';

  // --- Mobile Menu Toggle ---
  const menuToggle = document.getElementById('mobile-menu-toggle');
  const mobileMenu = document.getElementById('mobile-menu');

  if (menuToggle && mobileMenu) {
    menuToggle.addEventListener('click', function() {
      mobileMenu.classList.toggle('is-open');
      const isOpen = mobileMenu.classList.contains('is-open');
      menuToggle.setAttribute('aria-expanded', isOpen);
      menuToggle.setAttribute('aria-label', isOpen ? 'Menu sluiten' : 'Menu openen');
    });
  }

  // --- Portfolio Filter ---
  const filterButtons = document.querySelectorAll('.portfolio__filter');
  const portfolioCards = document.querySelectorAll('.portfolio__card');

  if (filterButtons.length > 0 && portfolioCards.length > 0) {
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const filteredEmptyState = document.querySelector('.portfolio__empty--filtered');

    filterButtons.forEach(function(btn) {
      btn.addEventListener('click', function() {
        const filter = this.getAttribute('data-filter');
        let visibleCount = 0;

        // Update active state and accessible pressed state
        filterButtons.forEach(function(b) {
          b.classList.remove('portfolio__filter--active');
          b.setAttribute('aria-pressed', 'false');
        });
        this.classList.add('portfolio__filter--active');
        this.setAttribute('aria-pressed', 'true');

        // Filter cards with fade animation, or switch immediately for reduced motion
        portfolioCards.forEach(function(card) {
          const categories = (card.getAttribute('data-category') || '').split(/\\s+/);
          const matches = filter === 'all' || categories.indexOf(filter) !== -1;
          if (matches) {
            visibleCount += 1;
            card.classList.remove('is-hidden');
            if (reducedMotion) {
              card.style.transition = 'none';
              card.style.opacity = '1';
              card.style.transform = 'none';
            } else {
              card.style.opacity = '0';
              card.style.transform = 'translateY(12px)';
              setTimeout(function() {
                card.style.transition = 'opacity 0.3s ease, transform 0.3s ease';
                card.style.opacity = '1';
                card.style.transform = 'translateY(0)';
              }, 50);
            }
          } else {
            card.classList.add('is-hidden');
          }
        });

        if (filteredEmptyState) filteredEmptyState.hidden = visibleCount !== 0;
      });
    });
  }

  // --- Sticky Header Shadow ---
  const header = document.getElementById('site-header');
  if (header) {
    window.addEventListener('scroll', function() {
      if (window.scrollY > 10) {
        header.style.boxShadow = '0 1px 3px rgba(0,0,0,0.08)';
      } else {
        header.style.boxShadow = 'none';
      }
    });
  }

  // --- Scroll Reveal Animation ---
  if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    const revealElements = document.querySelectorAll('.section');
    const observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.style.opacity = '1';
          entry.target.style.transform = 'translateY(0)';
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '-40px' });

    revealElements.forEach(function(el) {
      el.style.opacity = '0';
      el.style.transform = 'translateY(24px)';
      el.style.transition = 'opacity 0.5s cubic-bezier(0.23, 1, 0.32, 1), transform 0.5s cubic-bezier(0.23, 1, 0.32, 1)';
      observer.observe(el);
    });
  }
})();
